exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".faq-item p > a {\n  font-weight: 500;\n  text-decoration: underline;\n}\n", ""]);

// exports
